import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { AuthService, UserService } from '../services';
import { CanActivateFn } from '@angular/router';
import { Observable, of } from 'rxjs';
import { nrAction } from '../helpers/newrelic.helper';

@Injectable({
  providedIn: 'root'
})
export class ProgramDirectorCanActivate {
  private platformId = inject(PLATFORM_ID);

  constructor(private authService: AuthService, private userService: UserService) {
  }

  public canActivate(): Observable<boolean> {
    const hasToken = this.authService.getAuthToken() !== '';
    if (!hasToken) {
      nrAction('guard_blocked', { guard: 'ProgramDirectorGuard' });
      if (isPlatformBrowser(this.platformId)) {
        this.authService.login();
      }
      return of(false);
    }
    return of(true);
  }
}

export const ProgramDirectorGuard: CanActivateFn = () => {
  return inject(ProgramDirectorCanActivate).canActivate();
};
